import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  FaArrowLeft,
  FaCheckCircle,
  FaHome,
  FaBuilding,
  FaConciergeBell,
  FaTree,
  FaFootballBall,
  FaGlobe,
  FaShieldAlt,
  FaAward,
  FaPalette,
  FaTruck,
  FaHeadset,
  FaScroll,
  FaGem,
  FaStar,
  FaLayerGroup,
  FaLeaf,
  FaIndustry
} from 'react-icons/fa';

import {
  GiRolledCloth,
  GiGrass
} from 'react-icons/gi';

/*
============================================================
KK CARPETS IMAGES
============================================================

IMPORTANT:
Filenames are written EXACTLY as lowercase on purpose.

Make sure your folder contains:

src/logos/kkcarpets/

KK_Carpets.png
kkcarpet1.png
kkcarpet2.png
kkcarpet3.png
kkcarpet4.png
kkcarpet5.png
kkcarpet6.png
kkcarpet7.png
kkcarpet8.png

============================================================
*/

import logoImage from '../logos/kkcarpets/KK_Carpets.png';

import carpet1 from '../logos/kkcarpets/KKcarpet1.png';
import carpet2 from '../logos/kkcarpets/KKcarpet2.png';
import carpet3 from '../logos/kkcarpets/KKcarpet3.png';
import carpet4 from '../logos/kkcarpets/KKcarpet4.png';
import carpet5 from '../logos/kkcarpets/kkcarpet5.png';
import carpet6 from '../logos/kkcarpets/KKcarpet6.png';
import carpet7 from '../logos/kkcarpets/KKcarpet7.png';
import carpet8 from '../logos/kkcarpets/KKcarpet6.png';


/*
============================================================
MAIN COMPONENT
============================================================
*/

export default function KKCarpets() {

  const navigate = useNavigate();

  const [loaded, setLoaded] = useState(false);
  const [activeCard, setActiveCard] = useState(null);

  useEffect(() => {

    const timer = setTimeout(() => {
      setLoaded(true);
    }, 100);

    return () => clearTimeout(timer);

  }, []);


  return (
    <>
      <style>{`

        * {
          box-sizing: border-box;
        }

        html {
          scroll-behavior: smooth;
          width: 100%;
          overflow-x: hidden;
        }

        body {
          margin: 0;
          padding: 0;
          width: 100%;
          overflow-x: hidden;
          background: #101923;
        }

        #root {
          width: 100%;
          min-height: 100vh;
        }


        /* =====================================================
           ANIMATIONS
        ===================================================== */

        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(35px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }


        @keyframes fadeLeft {
          from {
            opacity: 0;
            transform: translateX(-45px);
          }

          to {
            opacity: 1;
            transform: translateX(0);
          }
        }


        @keyframes fadeRight {
          from {
            opacity: 0;
            transform: translateX(45px);
          }

          to {
            opacity: 1;
            transform: translateX(0);
          }
        }


        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(.88);
          }

          to {
            opacity: 1;
            transform: scale(1);
          }
        }


        @keyframes floating {
          0% {
            transform: translateY(0);
          }

          50% {
            transform: translateY(-7px);
          }

          100% {
            transform: translateY(0);
          }
        }


        @keyframes shine {
          0% {
            left: -120%;
          }

          100% {
            left: 120%;
          }
        }


        @keyframes pulseGold {
          0% {
            transform: scale(1);
          }

          50% {
            transform: scale(1.08);
          }

          100% {
            transform: scale(1);
          }
        }


        @keyframes imageFloat {
          0% {
            transform: scale(1.02) translateY(0);
          }

          50% {
            transform: scale(1.04) translateY(-3px);
          }

          100% {
            transform: scale(1.02) translateY(0);
          }
        }


        @keyframes borderGlow {
          0% {
            box-shadow: 0 0 0 rgba(197,160,89,0);
          }

          50% {
            box-shadow: 0 0 22px rgba(197,160,89,.20);
          }

          100% {
            box-shadow: 0 0 0 rgba(197,160,89,0);
          }
        }


        @keyframes rotateSlow {
          from {
            transform: rotate(0deg);
          }

          to {
            transform: rotate(360deg);
          }
        }


        @keyframes revealScale {
          from {
            opacity: 0;
            transform: scale(.92);
          }

          to {
            opacity: 1;
            transform: scale(1);
          }
        }


        /* =====================================================
           PAGE
        ===================================================== */

        .kk-page {
          opacity: 0;
          width: 100%;
        }

        .kk-page.loaded {
          opacity: 1;
          transition: opacity .8s ease;
        }


        .kk-reveal {
          animation: fadeUp .9s ease forwards;
        }

        .kk-left-reveal {
          animation: fadeLeft .9s ease forwards;
        }

        .kk-right-reveal {
          animation: fadeRight .9s ease forwards;
        }

        .kk-scale {
          animation: scaleIn .9s ease forwards;
        }


        .kk-delay-1 {
          animation-delay: .15s;
          opacity: 0;
          animation-fill-mode: forwards;
        }

        .kk-delay-2 {
          animation-delay: .30s;
          opacity: 0;
          animation-fill-mode: forwards;
        }

        .kk-delay-3 {
          animation-delay: .45s;
          opacity: 0;
          animation-fill-mode: forwards;
        }

        .kk-delay-4 {
          animation-delay: .60s;
          opacity: 0;
          animation-fill-mode: forwards;
        }

        .kk-delay-5 {
          animation-delay: .75s;
          opacity: 0;
          animation-fill-mode: forwards;
        }


        /* =====================================================
           BACK BUTTON
        ===================================================== */

        .kk-back-button {
          transition:
            transform .3s ease,
            box-shadow .3s ease,
            background-color .3s ease;
        }

        .kk-back-button:hover {
          transform: translateX(-5px);
          box-shadow: 0 8px 22px rgba(197,160,89,.35);
          background-color: #d7b86f !important;
        }


        /* =====================================================
           HERO
        ===================================================== */

        .kk-hero-image {
          transition:
            transform 1.2s cubic-bezier(.2,.8,.2,1),
            filter .7s ease;
        }

        .kk-hero:hover .kk-hero-image {
          transform: scale(1.055);
          filter: saturate(1.08);
        }


        .kk-badge {
          transition:
            transform .4s ease,
            box-shadow .4s ease;
        }

        .kk-hero:hover .kk-badge {
          transform: translateY(-5px);
          box-shadow: 0 18px 40px rgba(0,0,0,.28);
        }


        .kk-arrow {
          animation: floating 2s ease-in-out infinite;
        }


        /* =====================================================
           PRODUCT CARDS
        ===================================================== */

        .kk-product-card {
          transition:
            transform .45s cubic-bezier(.2,.8,.2,1),
            box-shadow .45s ease,
            border-color .45s ease;
          position: relative;
        }


        .kk-product-card::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 3px;
          background: linear-gradient(
            90deg,
            transparent,
            #c5a059,
            transparent
          );
          transform: scaleX(0);
          transition: transform .45s ease;
          z-index: 5;
        }


        .kk-product-card:hover {
          transform: translateY(-11px);
          box-shadow:
            0 22px 45px rgba(11,37,69,.17);
          border-color: #c5a059;
        }


        .kk-product-card:hover::before {
          transform: scaleX(1);
        }


        .kk-card-image {
          transition:
            transform .8s cubic-bezier(.2,.8,.2,1),
            filter .6s ease;
        }


        .kk-product-card:hover .kk-card-image {
          transform: scale(1.09);
          filter: saturate(1.08);
        }


        .kk-card-image-wrapper {
          position: relative;
        }


        .kk-card-image-wrapper::after {
          content: "";
          position: absolute;
          inset: 0;
          background:
            linear-gradient(
              135deg,
              rgba(255,255,255,.10),
              transparent 45%,
              rgba(11,37,69,.12)
            );
          pointer-events: none;
        }


        /* =====================================================
           APPLICATION CARDS
        ===================================================== */

        .kk-app-item {
          transition:
            transform .35s ease,
            background-color .35s ease,
            box-shadow .35s ease;
          padding: 8px 4px;
          border-radius: 8px;
        }


        .kk-app-item:hover {
          transform: translateY(-8px);
          background-color: #fff;
          box-shadow: 0 8px 20px rgba(11,37,69,.08);
        }


        .kk-app-item:hover .kk-app-icon {
          animation: floating 1.4s ease infinite;
          background-color: #c5a059;
          color: #0b2545;
        }


        .kk-app-icon {
          transition:
            background-color .35s ease,
            color .35s ease,
            transform .35s ease;
        }


        /* =====================================================
           STRENGTHS
        ===================================================== */

        .kk-strength-row {
          transition:
            transform .3s ease,
            padding-left .3s ease,
            background-color .3s ease;
          padding: 5px;
          border-radius: 7px;
        }


        .kk-strength-row:hover {
          transform: translateX(6px);
          background-color: rgba(197,160,89,.06);
        }


        .kk-strength-row:hover .kk-strength-icon {
          animation: pulseGold .6s ease;
        }


        /* =====================================================
           GALLERY
        ===================================================== */

        .kk-gallery-card {
          transition:
            transform .45s ease,
            box-shadow .45s ease,
            border-color .45s ease;
          border: 1px solid transparent;
        }


        .kk-gallery-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 18px 35px rgba(0,0,0,.18);
          border-color: #c5a059;
        }


        .kk-gallery-card:hover img {
          transform: scale(1.09);
          filter: saturate(1.08);
        }


        .kk-gallery-card img {
          transition:
            transform .8s ease,
            filter .6s ease;
        }


        /* =====================================================
           CALLOUT
        ===================================================== */

        .kk-callout {
          position: relative;
          overflow: hidden;
        }


        .kk-callout::after {
          content: "";
          position: absolute;
          top: 0;
          left: -120%;
          width: 70%;
          height: 100%;
          background:
            linear-gradient(
              90deg,
              transparent,
              rgba(255,255,255,.10),
              transparent
            );
          transform: skewX(-25deg);
        }


        .kk-callout:hover::after {
          animation: shine 1.2s ease;
        }


        /* =====================================================
           IMAGE STRIP
        ===================================================== */

        .kk-image-strip-card {
          overflow: hidden;
          position: relative;
        }


        .kk-image-strip-card img {
          transition:
            transform .8s ease,
            filter .6s ease;
        }


        .kk-image-strip-card:hover img {
          transform: scale(1.10);
          filter: brightness(1.05) saturate(1.1);
        }


        /* =====================================================
           DECORATION
        ===================================================== */

        .kk-decoration {
          animation: rotateSlow 18s linear infinite;
        }


        .kk-floating-gem {
          animation: floating 2.5s ease-in-out infinite;
        }


        /* =====================================================
           LARGE SCREEN
        ===================================================== */

        @media(min-width: 1400px) {

          .kk-poster {
            padding: 35px !important;
          }

          .kk-hero-section {
            min-height: 540px !important;
          }

          .kk-hero-left {
            padding: 55px 60px !important;
          }

          .kk-main-title {
            font-size: 60px !important;
          }

          .kk-company-name {
            font-size: 40px !important;
          }

          .kk-hero-right {
            min-height: 540px !important;
          }

          .kk-card-image-wrapper {
            height: 220px !important;
          }

          .kk-card-image {
            height: 100% !important;
          }
        }


        /* =====================================================
           TABLET
        ===================================================== */

        @media(max-width: 1100px) {

          .kk-hero-section {
            flex-direction: column !important;
          }

          .kk-hero-left {
            width: 100% !important;
            min-height: 360px;
          }

          .kk-hero-right {
            width: 100% !important;
            height: 450px !important;
            min-height: 450px !important;
          }

          .kk-products {
            grid-template-columns:
              repeat(3, 1fr) !important;
          }

          .kk-two-column {
            flex-direction: column !important;
          }

          .kk-app-grid {
            grid-template-columns:
              repeat(5, 1fr) !important;
          }

          .kk-about-content {
            max-width: 900px !important;
          }
        }


        /* =====================================================
           MOBILE
        ===================================================== */

        @media(max-width: 700px) {

          .kk-page-wrapper {
            padding: 8px 4px !important;
          }

          .kk-poster {
            padding: 10px !important;
            border-radius: 0 !important;
          }

          .kk-top-nav {
            padding: 8px 10px !important;
          }

          .kk-products {
            grid-template-columns:
              1fr !important;
          }

          .kk-gallery {
            grid-template-columns:
              1fr !important;
            height: auto !important;
          }

          .kk-gallery-card {
            height: 190px !important;
          }

          .kk-app-grid {
            grid-template-columns:
              repeat(2, 1fr) !important;
            gap: 15px !important;
          }

          .kk-footer {
            flex-direction: column !important;
            gap: 15px !important;
            text-align: center;
          }

          .kk-callout-text {
            font-size: 11px !important;
          }

          .kk-hero-right {
            height: 300px !important;
            min-height: 300px !important;
          }

          .kk-main-title {
            font-size: 32px !important;
          }

          .kk-about-text {
            font-size: 12px !important;
          }

          .kk-section-divider {
            flex-wrap: wrap !important;
          }

          .kk-divider-line {
            width: 45px !important;
          }

          .kk-about-content {
            max-width: 100% !important;
          }

          .kk-callout {
            padding: 12px 10px !important;
          }

          .kk-image-strip {
            grid-template-columns: 1fr !important;
            height: auto !important;
          }

          .kk-image-strip-card {
            height: 170px !important;
          }
        }


        /* =====================================================
           SMALL MOBILE
        ===================================================== */

        @media(max-width: 450px) {

          .kk-hero-left {
            padding: 25px 18px !important;
          }

          .kk-company-name {
            font-size: 24px !important;
          }

          .kk-main-title {
            font-size: 28px !important;
          }

          .kk-tagline {
            font-size: 13px !important;
          }

          .kk-hero-right {
            height: 250px !important;
            min-height: 250px !important;
          }

          .kk-badge {
            padding: 12px 15px !important;
          }

          .kk-badge-title {
            font-size: 11px !important;
          }

          .kk-badge-sub {
            font-size: 9px !important;
          }

          .kk-section-title {
            font-size: 13px !important;
          }
        }

      `}</style>


      {/* =====================================================
          PAGE
      ===================================================== */}

      <div
        className={`kk-page ${loaded ? 'loaded' : ''}`}
        style={styles.pageBackground}
      >


        {/* ===================================================
            TOP NAV
        =================================================== */}

        <div
          className="kk-top-nav"
          style={styles.topNav}
        >

          <button
            className="kk-back-button"
            style={styles.backButton}
            onClick={() => navigate('/')}
          >

            <FaArrowLeft
              className="kk-arrow"
              style={{
                marginRight: '8px'
              }}
            />

            Back to All Sectors

          </button>

        </div>


        {/* ===================================================
            POSTER
        =================================================== */}

        <div
          className="kk-poster"
          style={styles.posterCard}
        >


          {/* =================================================
              HERO
          ================================================= */}

          <section
            className="kk-hero kk-hero-section"
            style={styles.heroSection}
          >


            {/* LEFT */}

            <div
              className="kk-left-reveal kk-hero-left"
              style={styles.heroLeftBar}
            >

              <div style={styles.brandCrest}>

                <img
                  src={logoImage}
                  alt="KK Carpets Logo"
                  style={styles.logoImage}
                />

                <div
                  className="kk-floating-gem"
                  style={styles.crestDecoration}
                >
                  ❖
                </div>

                <div style={styles.crestPattern}>
                  ✦ ❖ ✦
                </div>

                <h2
                  className="kk-company-name"
                  style={styles.companyName}
                >
                  KK Carpets
                </h2>

                <div style={styles.crestLine}>
                  ─────────
                </div>

                <div style={styles.crestPattern}>
                  ✦ ❖ ✦
                </div>

              </div>


              <div
                className="kk-delay-2 kk-reveal"
                style={styles.heroTitleBox}
              >

                <div style={styles.heroMiniLabel}>
                  PREMIUM FLOORING COLLECTION
                </div>

                <h1
                  className="kk-main-title"
                  style={styles.mainTitle}
                >

                  CARPET

                  <br />

                  <span
                    style={{
                      color: '#c5a059'
                    }}
                  >
                    DIVISION
                  </span>

                </h1>


                <div
                  style={styles.goldDividerLine}
                />


                <p
                  className="kk-tagline"
                  style={styles.tagline}
                >

                  Crafting Comfort.

                  <br />

                  Delivering Performance.

                </p>

              </div>

            </div>


            {/* RIGHT IMAGE */}

            <div
              className="kk-right-reveal kk-hero-right"
              style={styles.heroRightImageArea}
            >

              <img
                className="kk-hero-image"
                src={carpet1}
                alt="KK Carpets Premium Flooring"
                style={styles.heroImg}
              />


              <div
                className="kk-hero-image-overlay"
                style={styles.heroImageOverlay}
              />


              {/* HERO BADGE */}

              <div
                className="kk-badge"
                style={styles.heroOverlayBadge}
              >

                <h3
                  className="kk-badge-title"
                  style={styles.badgeTitle}
                >
                  QUALITY FLOORING SOLUTIONS
                </h3>

                <p
                  className="kk-badge-sub"
                  style={styles.badgeSub}
                >

                  DESIGNED FOR DURABILITY,

                  <br />

                  COMFORT &amp; MODERN LIVING.

                </p>

              </div>

            </div>

          </section>


          {/* =================================================
              ABOUT
          ================================================= */}

          <section
            className="kk-reveal kk-delay-1"
            style={styles.aboutSection}
          >

            <div
              className="kk-about-content"
              style={styles.aboutContent}
            >

              <div style={styles.smallGoldLabel}>
                ✦ ABOUT KK CARPETS ✦
              </div>

              <h2 style={styles.sectionHeader}>
                ABOUT THE DIVISION
              </h2>

              <div style={styles.goldOrnament}>
                ❖ ─── ❖ ─── ❖
              </div>

              <p
                className="kk-about-text"
                style={styles.aboutParagraph}
              >

                <strong>
                  KK Carpets
                </strong>

                {' '}is the group's dedicated carpet

                <strong>
                  {' '}manufacturing
                </strong>

                {' '}division, specializing in the production
                of high-quality

                <strong>
                  {' '}tufted and woven carpets
                </strong>

                , along with the import and supply of

                <strong>
                  {' '}premium artificial grass
                </strong>

                .

              </p>


              <p
                className="kk-about-text"
                style={styles.aboutParagraph}
              >

                With decades of textile expertise and a
                commitment to excellence, we deliver flooring
                solutions that combine durability, comfort,
                and aesthetic appeal for residential,
                commercial, and outdoor spaces.

              </p>

            </div>

          </section>


          {/* =================================================
              CORE PRODUCTS TITLE
          ================================================= */}

          <div
            className="kk-reveal kk-delay-2 kk-section-divider"
            style={styles.sectionDividerRow}
          >

            <span
              className="kk-divider-line"
              style={styles.dividerLine}
            />

            <span style={styles.dividerDiamond}>
              ❖
            </span>

            <h2
              className="kk-section-title"
              style={styles.sectionTitle}
            >
              OUR CORE PRODUCT CATEGORIES
            </h2>

            <span style={styles.dividerDiamond}>
              ❖
            </span>

            <span
              className="kk-divider-line"
              style={styles.dividerLine}
            />

          </div>


          {/* =================================================
              PRODUCTS
          ================================================= */}

          <section
            className="kk-products kk-reveal kk-delay-3"
            style={styles.productsGrid}
          >


            {/* TUFTED */}

            <div
              className="kk-product-card"
              style={{
                ...styles.productCard,
                ...(activeCard === 1
                  ? styles.activeCard
                  : {})
              }}
              onMouseEnter={() => setActiveCard(1)}
              onMouseLeave={() => setActiveCard(null)}
            >

              <div
                style={styles.cardHeaderNavy}
              >

                <div
                  style={styles.cardHeaderIconCircle}
                >
                  <GiRolledCloth />
                </div>

                <h3
                  style={styles.cardHeaderTitle}
                >
                  TUFTED CARPETS
                </h3>

              </div>


              <div
                className="kk-card-image-wrapper"
                style={styles.cardImageWrapper}
              >

                <img
                  className="kk-card-image"
                  src={carpet2}
                  alt="Tufted Carpets"
                  style={styles.cardImg}
                />

              </div>


              <div style={styles.cardList}>

                <Check text="Soft, versatile & cost-effective" />

                <Check text="Ideal for residential & commercial use" />

                <Check text="Wide range of textures, colors & designs" />

                <Check text="Comfortable feel with excellent finish" />

              </div>

            </div>


            {/* WOVEN */}

            <div
              className="kk-product-card"
              style={{
                ...styles.productCard,
                ...(activeCard === 2
                  ? styles.activeCard
                  : {})
              }}
              onMouseEnter={() => setActiveCard(2)}
              onMouseLeave={() => setActiveCard(null)}
            >

              <div
                style={styles.cardHeaderNavy}
              >

                <div
                  style={styles.cardHeaderIconCircle}
                >
                  <FaScroll />
                </div>

                <h3
                  style={styles.cardHeaderTitle}
                >
                  WOVEN CARPETS
                </h3>

              </div>


              <div
                className="kk-card-image-wrapper"
                style={styles.cardImageWrapper}
              >

                <img
                  className="kk-card-image"
                  src={carpet3}
                  alt="Woven Carpets"
                  style={styles.cardImg}
                />

              </div>


              <div style={styles.cardList}>

                <Check text="Strong structure & long-lasting" />

                <Check text="Suitable for high-traffic environments" />

                <Check text="Premium finish with traditional durability" />

                <Check text="Elegant designs with rich weaving" />

              </div>

            </div>


            {/* ARTIFICIAL GRASS */}

            <div
              className="kk-product-card"
              style={{
                ...styles.productCard,
                ...(activeCard === 3
                  ? styles.activeCardGreen
                  : {})
              }}
              onMouseEnter={() => setActiveCard(3)}
              onMouseLeave={() => setActiveCard(null)}
            >

              <div
                style={styles.cardHeaderGreen}
              >

                <div
                  style={styles.cardHeaderIconCircleGreen}
                >
                  <GiGrass />
                </div>

                <h3
                  style={styles.cardHeaderTitle}
                >

                  ARTIFICIAL GRASS

                  <br />

                  <span
                    style={{
                      fontSize: '10px',
                      fontWeight: 'normal'
                    }}
                  >
                    (IMPORTED)
                  </span>

                </h3>

              </div>


              <div
                className="kk-card-image-wrapper"
                style={styles.cardImageWrapper}
              >

                <img
                  className="kk-card-image"
                  src={carpet4}
                  alt="Artificial Grass"
                  style={styles.cardImg}
                />

              </div>


              <div style={styles.cardList}>

                <Check
                  green
                  text="High-quality synthetic turf solutions"
                />

                <Check
                  green
                  text="Natural look & feel"
                />

                <Check
                  green
                  text="Low maintenance & long-lasting"
                />

                <Check
                  green
                  text="Ideal for landscaping, sports & decorative use"
                />

              </div>

            </div>

          </section>


          {/* =================================================
              SECOND IMAGE SHOWCASE
          ================================================= */}

          <section
            className="kk-image-strip kk-reveal kk-delay-4"
            style={styles.imageStrip}
          >

            <ImageFeature
              image={carpet5}
              icon={<FaGem />}
              title="PREMIUM QUALITY"
              text="Carefully selected materials"
            />

            <ImageFeature
              image={carpet6}
              icon={<FaLayerGroup />}
              title="RICH DESIGNS"
              text="Textures for every environment"
            />

            <ImageFeature
              image={carpet7}
              icon={<FaIndustry />}
              title="ADVANCED CRAFT"
              text="Manufacturing excellence"
            />

          </section>


          {/* =================================================
              APPLICATION + STRENGTH
          ================================================= */}

          <section
            className="kk-two-column kk-reveal kk-delay-4"
            style={styles.twoColSection}
          >


            {/* APPLICATION */}

            <div
              style={styles.appAreasBox}
            >

              <div
                style={styles.subSectionTitleRow}
              >

                <span style={styles.dividerDiamond}>
                  ❖
                </span>

                <h3 style={styles.subHeader}>
                  APPLICATION AREAS
                </h3>

                <span style={styles.dividerDiamond}>
                  ❖
                </span>

              </div>


              <div
                className="kk-app-grid"
                style={styles.appIconsGrid}
              >

                <Application
                  icon={<FaHome />}
                  text={
                    <>
                      RESIDENTIAL
                      <br />
                      SPACES
                    </>
                  }
                />

                <Application
                  icon={<FaBuilding />}
                  text={
                    <>
                      OFFICES &amp;
                      <br />
                      COMMERCIAL AREAS
                    </>
                  }
                />

                <Application
                  icon={<FaConciergeBell />}
                  text={
                    <>
                      HOSPITALITY
                      <br />
                      SECTOR
                    </>
                  }
                />

                <Application
                  icon={<FaTree />}
                  text={
                    <>
                      LANDSCAPING &amp;
                      <br />
                      OUTDOOR AREAS
                    </>
                  }
                />

                <Application
                  icon={<FaFootballBall />}
                  text={
                    <>
                      SPORTS &amp;
                      <br />
                      RECREATIONAL USE
                    </>
                  }
                />

              </div>

            </div>


            {/* STRENGTHS */}

            <div
              style={styles.strengthsBox}
            >

              <div
                style={styles.subSectionTitleRow}
              >

                <span style={styles.dividerDiamond}>
                  ❖
                </span>

                <h3 style={styles.subHeader}>
                  OUR STRENGTHS
                </h3>

                <span style={styles.dividerDiamond}>
                  ❖
                </span>

              </div>


              <div style={styles.strengthsList}>

                <Strength
                  icon={<FaShieldAlt />}
                  text="Specialized in Tufted & Weaving Carpet Manufacturing"
                />

                <Strength
                  icon={<FaAward />}
                  text="High-quality Imports of Artificial Grass"
                />

                <Strength
                  icon={<FaPalette />}
                  text="Consistent Quality & Modern Designs"
                />

                <Strength
                  icon={<FaTruck />}
                  text="Strong Supply Network & Reliable Deliveries"
                />

                <Strength
                  icon={<FaHeadset />}
                  text="Customer-focused Solutions & After Sales Support"
                />

              </div>

            </div>

          </section>


          {/* =================================================
              PREMIUM GALLERY
          ================================================= */}

          <div
            className="kk-reveal kk-delay-5"
            style={styles.galleryHeading}
          >

            <span style={styles.galleryHeadingLine} />

            <FaStar style={styles.galleryStar} />

            <h2 style={styles.galleryTitle}>
              OUR FLOORING COLLECTION
            </h2>

            <FaStar style={styles.galleryStar} />

            <span style={styles.galleryHeadingLine} />

          </div>


          <section
            className="kk-gallery kk-reveal kk-delay-5"
            style={styles.bottomGalleryGrid}
          >

            <Gallery
              image={carpet8}
              alt="Premium Carpet Collection"
            />

            <Gallery
              image={carpet5}
              alt="Luxury Carpet"
            />

            <Gallery
              image={carpet6}
              alt="Modern Carpet Design"
            />

          </section>


          {/* =================================================
              CALLOUT
          ================================================= */}

          <div
            className="kk-callout kk-reveal"
            style={styles.calloutBanner}
          >

            <div style={styles.ornamentLeft}>
              ❖
            </div>

            <p
              className="kk-callout-text"
              style={styles.calloutText}
            >

              FLOORING SOLUTIONS DESIGNED FOR

              <br />

              <strong>
                COMFORT, DURABILITY &amp; MODERN LIFESTYLES.
              </strong>

            </p>

            <div style={styles.ornamentRight}>
              ❖
            </div>

          </div>


          {/* =================================================
              FOOTER
          ================================================= */}

          <footer
            className="kk-footer kk-reveal"
            style={styles.footer}
          >

            <div style={styles.footerBadge}>
              09
            </div>


            <div style={styles.footerCompany}>

              <strong>
                ASHRAF GROUP OF INDUSTRIES
              </strong>

              <span>
                Building Legacy. Powering the Future.
              </span>

            </div>


            <div style={styles.footerLink}>

              <FaGlobe
                style={{
                  marginRight: '6px',
                  color: '#0b2545'
                }}
              />

              <a
                href="https://www.ashrafiafood.com"
                target="_blank"
                rel="noreferrer"
                style={styles.linkText}
              >
                www.ashrafiafood.com
              </a>

            </div>

          </footer>

        </div>

      </div>

    </>
  );
}


/*
============================================================
CHECK COMPONENT
============================================================
*/

function Check({
  text,
  green = false
}) {

  return (

    <div style={styles.checkItem}>

      <FaCheckCircle
        style={
          green
            ? styles.checkIconGreen
            : styles.checkIcon
        }
      />

      <span>
        {text}
      </span>

    </div>

  );
}


/*
============================================================
APPLICATION COMPONENT
============================================================
*/

function Application({
  icon,
  text
}) {

  return (

    <div
      className="kk-app-item"
      style={styles.appItem}
    >

      <div
        className="kk-app-icon"
        style={styles.appIconCircle}
      >
        {icon}
      </div>

      <span style={styles.appLabel}>
        {text}
      </span>

    </div>

  );
}


/*
============================================================
STRENGTH COMPONENT
============================================================
*/

function Strength({
  icon,
  text
}) {

  return (

    <div
      className="kk-strength-row"
      style={styles.strengthRow}
    >

      <div
        className="kk-strength-icon"
        style={styles.strengthBadgeIcon}
      >
        {icon}
      </div>

      <span style={styles.strengthText}>
        {text}
      </span>

    </div>

  );
}


/*
============================================================
IMAGE FEATURE COMPONENT
============================================================
*/

function ImageFeature({
  image,
  icon,
  title,
  text
}) {

  return (

    <div
      className="kk-image-strip-card"
      style={styles.imageStripCard}
    >

      <img
        src={image}
        alt={title}
        style={styles.imageStripImg}
      />

      <div style={styles.imageStripOverlay}>

        <div style={styles.imageFeatureIcon}>
          {icon}
        </div>

        <div>

          <h3 style={styles.imageFeatureTitle}>
            {title}
          </h3>

          <p style={styles.imageFeatureText}>
            {text}
          </p>

        </div>

      </div>

    </div>

  );
}


/*
============================================================
GALLERY COMPONENT
============================================================
*/

function Gallery({
  image,
  alt
}) {

  return (

    <div
      className="kk-gallery-card"
      style={styles.bottomGalleryCard}
    >

      <img
        src={image}
        alt={alt}
        style={styles.galleryImg}
      />

      <div style={styles.galleryOverlay}>
        <span>
          {alt}
        </span>
      </div>

    </div>

  );
}


/*
============================================================
STYLES
============================================================
*/

const styles = {


  /* ========================================================
     PAGE
  ======================================================== */

  pageBackground: {

    backgroundColor: '#101923',

    backgroundImage:
      `
      radial-gradient(
        circle at 15% 15%,
        rgba(197,160,89,.10),
        transparent 25%
      ),
      radial-gradient(
        circle at 85% 85%,
        rgba(11,37,69,.9),
        transparent 35%
      )
      `,

    minHeight: '100vh',

    width: '100%',

    padding: '20px 0',

    fontFamily:
      '"Georgia", "Times New Roman", serif',

    color: '#333'

  },


  /* ========================================================
     NAV
  ======================================================== */

  topNav: {

    width: '100%',

    padding: '0 25px',

    margin: '0 auto 15px auto',

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'flex-start'

  },


  backButton: {

    backgroundColor: '#c5a059',

    color: '#0b2545',

    border: 'none',

    padding: '11px 19px',

    borderRadius: '5px',

    cursor: 'pointer',

    display: 'flex',

    alignItems: 'center',

    fontWeight: 'bold',

    fontFamily: 'sans-serif',

    letterSpacing: '.2px'

  },


  /* ========================================================
     POSTER
  ======================================================== */

  posterCard: {

    width: '100%',

    maxWidth: 'none',

    margin: '0',

    backgroundColor: '#fffdf9',

    borderRadius: '0',

    boxShadow:
      '0 20px 60px rgba(0,0,0,.45)',

    overflow: 'hidden',

    padding: '25px'

  },


  /* ========================================================
     HERO
  ======================================================== */

  heroSection: {

    display: 'flex',

    width: '100%',

    minHeight: '430px',

    borderRadius: '9px',

    overflow: 'hidden',

    backgroundColor: '#0b2545',

    position: 'relative',

    boxShadow:
      '0 18px 40px rgba(11,37,69,.22)'

  },


  heroLeftBar: {

    width: '34%',

    backgroundColor: '#0b2545',

    backgroundImage:
      `
      radial-gradient(
        circle at 20% 20%,
        rgba(197,160,89,.12),
        transparent 30%
      ),
      linear-gradient(
        135deg,
        #0b2545,
        #102f52
      )
      `,

    color: '#fff',

    padding: '40px 45px',

    display: 'flex',

    flexDirection: 'column',

    justifyContent: 'space-between',

    zIndex: 2,

    position: 'relative'

  },


  logoImage: {

    width: '145px',

    height: 'auto',

    maxHeight: '95px',

    objectFit: 'contain',

    display: 'block',

    margin: '0 auto 12px auto',

    filter:
      'drop-shadow(0 7px 12px rgba(0,0,0,.25))'

  },


  brandCrest: {

    textAlign: 'center',

    color: '#c5a059'

  },


  crestDecoration: {

    fontSize: '25px',

    lineHeight: '1'

  },


  crestPattern: {

    fontSize: '13px',

    letterSpacing: '5px',

    margin: '2px 0'

  },


  companyName: {

    margin: '5px 0',

    fontSize: '29px',

    color: '#c5a059',

    fontFamily:
      '"Cinzel", "Georgia", serif',

    letterSpacing: '1px',

    fontWeight: 'bold',

    textShadow:
      '0 4px 10px rgba(0,0,0,.25)'

  },


  crestLine: {

    fontSize: '11px',

    color: '#c5a059',

    letterSpacing: '2px'

  },


  heroTitleBox: {

    marginTop: '25px'

  },


  heroMiniLabel: {

    fontFamily: 'sans-serif',

    fontSize: '9px',

    letterSpacing: '2px',

    color: 'rgba(255,255,255,.60)',

    marginBottom: '8px'

  },


  mainTitle: {

    fontSize: '48px',

    color: '#fff',

    letterSpacing: '2px',

    lineHeight: '1.05',

    margin: 0,

    fontWeight: 'bold',

    textShadow:
      '0 5px 18px rgba(0,0,0,.20)'

  },


  goldDividerLine: {

    height: '2px',

    backgroundColor: '#c5a059',

    width: '90px',

    margin: '15px 0',

    boxShadow:
      '0 0 12px rgba(197,160,89,.35)'

  },


  tagline: {

    fontSize: '15px',

    color: '#c5a059',

    fontStyle: 'italic',

    margin: 0,

    lineHeight: '1.5'

  },


  /* ========================================================
     HERO IMAGE
  ======================================================== */

  heroRightImageArea: {

    width: '66%',

    position: 'relative',

    overflow: 'hidden',

    minHeight: '430px',

    backgroundColor: '#111'

  },


  heroImg: {

    width: '100%',

    height: '100%',

    objectFit: 'cover',

    display: 'block'

  },


  heroImageOverlay: {

    position: 'absolute',

    inset: 0,

    background:
      'linear-gradient(90deg, rgba(11,37,69,.18), transparent 50%, rgba(0,0,0,.15))',

    pointerEvents: 'none'

  },


  heroOverlayBadge: {

    position: 'absolute',

    bottom: 0,

    right: 0,

    backgroundColor:
      'rgba(11,37,69,.94)',

    color: '#fff',

    padding: '18px 28px',

    borderTopLeftRadius: '28px',

    borderLeft:
      '3px solid #c5a059',

    borderTop:
      '3px solid #c5a059',

    textAlign: 'right',

    backdropFilter: 'blur(4px)'

  },


  badgeTitle: {

    margin: 0,

    fontSize: '15px',

    color: '#c5a059',

    letterSpacing: '1px'

  },


  badgeSub: {

    margin: '5px 0 0',

    fontSize: '11px',

    color: '#fff',

    lineHeight: '1.4',

    fontWeight: 'bold'

  },


  /* ========================================================
     ABOUT
  ======================================================== */

  aboutSection: {

    margin:
      '38px auto 20px',

    textAlign: 'center',

    width: '100%'

  },


  aboutContent: {

    maxWidth: '1000px',

    margin: '0 auto',

    padding: '0 20px'

  },


  smallGoldLabel: {

    color: '#c5a059',

    fontFamily: 'sans-serif',

    fontSize: '9px',

    letterSpacing: '2px',

    marginBottom: '8px',

    fontWeight: 'bold'

  },


  sectionHeader: {

    fontSize: '24px',

    color: '#0b2545',

    margin: 0,

    letterSpacing: '1.5px'

  },


  goldOrnament: {

    color: '#c5a059',

    fontSize: '12px',

    margin:
      '7px 0 13px'

  },


  aboutParagraph: {

    fontSize: '14px',

    lineHeight: '1.7',

    color: '#333',

    marginBottom: '10px'

  },


  /* ========================================================
     DIVIDER
  ======================================================== */

  sectionDividerRow: {

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'center',

    gap: '10px',

    margin:
      '32px 0 20px'

  },


  dividerLine: {

    height: '1px',

    width: '120px',

    backgroundColor: '#d4b36b'

  },


  dividerDiamond: {

    color: '#c5a059',

    fontSize: '12px'

  },


  sectionTitle: {

    margin: 0,

    fontSize: '18px',

    color: '#0b2545',

    letterSpacing: '1px',

    textAlign: 'center'

  },


  /* ========================================================
     PRODUCTS
  ======================================================== */

  productsGrid: {

    display: 'grid',

    gridTemplateColumns:
      'repeat(3, 1fr)',

    gap: '22px',

    marginBottom: '30px',

    width: '100%'

  },


  productCard: {

    border:
      '1px solid #dcd6cd',

    borderRadius: '9px',

    overflow: 'hidden',

    backgroundColor: '#fff',

    boxShadow:
      '0 5px 15px rgba(0,0,0,.06)'

  },


  activeCard: {

    borderColor: '#c5a059',

    boxShadow:
      '0 15px 35px rgba(197,160,89,.18)'

  },


  activeCardGreen: {

    borderColor: '#4b8e3b',

    boxShadow:
      '0 15px 35px rgba(46,125,50,.15)'

  },


  cardHeaderNavy: {

    background:
      'linear-gradient(135deg,#0b2545,#153c62)',

    color: '#fff',

    padding: '13px',

    textAlign: 'center',

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'center',

    gap: '9px'

  },


  cardHeaderGreen: {

    background:
      'linear-gradient(135deg,#175b24,#287b35)',

    color: '#fff',

    padding: '11px',

    textAlign: 'center',

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'center',

    gap: '9px'

  },


  cardHeaderIconCircle: {

    color: '#c5a059',

    fontSize: '21px'

  },


  cardHeaderIconCircleGreen: {

    color: '#8bc34a',

    fontSize: '21px'

  },


  cardHeaderTitle: {

    margin: 0,

    fontSize: '14px',

    color: '#fff',

    letterSpacing: '.5px',

    fontFamily:
      'Georgia, serif'

  },


  cardImageWrapper: {

    height: '190px',

    overflow: 'hidden',

    backgroundColor: '#eee'

  },


  cardImg: {

    width: '100%',

    height: '100%',

    objectFit: 'cover',

    display: 'block'

  },


  cardList: {

    padding: '16px 14px',

    display: 'flex',

    flexDirection: 'column',

    gap: '9px',

    backgroundColor: '#faf8f5',

    minHeight: '140px'

  },


  checkItem: {

    display: 'flex',

    alignItems: 'flex-start',

    gap: '7px',

    fontSize: '12px',

    color: '#333',

    lineHeight: '1.4'

  },


  checkIcon: {

    color: '#c5a059',

    fontSize: '13px',

    marginTop: '1px',

    flexShrink: 0

  },


  checkIconGreen: {

    color: '#2e7d32',

    fontSize: '13px',

    marginTop: '1px',

    flexShrink: 0

  },


  /* ========================================================
     IMAGE STRIP
  ======================================================== */

  imageStrip: {

    display: 'grid',

    gridTemplateColumns:
      'repeat(3, 1fr)',

    gap: '15px',

    width: '100%',

    height: '190px',

    marginBottom: '25px'

  },


  imageStripCard: {

    borderRadius: '9px',

    overflow: 'hidden',

    position: 'relative',

    backgroundColor: '#111',

    boxShadow:
      '0 8px 20px rgba(0,0,0,.12)'

  },


  imageStripImg: {

    width: '100%',

    height: '100%',

    objectFit: 'cover',

    display: 'block'

  },


  imageStripOverlay: {

    position: 'absolute',

    left: 0,

    right: 0,

    bottom: 0,

    padding: '14px',

    display: 'flex',

    alignItems: 'center',

    gap: '10px',

    background:
      'linear-gradient(transparent,rgba(5,18,32,.94))',

    color: '#fff'

  },


  imageFeatureIcon: {

    width: '35px',

    height: '35px',

    borderRadius: '50%',

    backgroundColor: '#c5a059',

    color: '#0b2545',

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'center',

    flexShrink: 0

  },


  imageFeatureTitle: {

    margin: 0,

    color: '#fff',

    fontSize: '11px',

    letterSpacing: '1px'

  },


  imageFeatureText: {

    margin: '3px 0 0',

    fontSize: '9px',

    color: 'rgba(255,255,255,.8)'

  },


  /* ========================================================
     TWO COLUMNS
  ======================================================== */

  twoColSection: {

    display: 'flex',

    gap: '22px',

    marginBottom: '25px',

    width: '100%'

  },


  appAreasBox: {

    flex: 1.2,

    border:
      '1px solid #dcd6cd',

    borderRadius: '9px',

    padding: '20px',

    backgroundColor: '#fffdf9',

    boxShadow:
      '0 6px 18px rgba(0,0,0,.04)'

  },


  strengthsBox: {

    flex: 1,

    border:
      '1px solid #dcd6cd',

    borderRadius: '9px',

    padding: '20px',

    backgroundColor: '#fffdf9',

    boxShadow:
      '0 6px 18px rgba(0,0,0,.04)'

  },


  subSectionTitleRow: {

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'center',

    gap: '8px',

    marginBottom: '18px'

  },


  subHeader: {

    margin: 0,

    fontSize: '15px',

    color: '#0b2545',

    letterSpacing: '1px'

  },


  appIconsGrid: {

    display: 'grid',

    gridTemplateColumns:
      'repeat(5, 1fr)',

    gap: '12px',

    marginTop: '10px'

  },


  appItem: {

    display: 'flex',

    flexDirection: 'column',

    alignItems: 'center',

    textAlign: 'center'

  },


  appIconCircle: {

    width: '45px',

    height: '45px',

    borderRadius: '50%',

    backgroundColor: '#0b2545',

    color: '#c5a059',

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'center',

    fontSize: '18px',

    marginBottom: '8px'

  },


  appLabel: {

    fontSize: '9px',

    fontWeight: 'bold',

    color: '#0b2545',

    fontFamily: 'sans-serif',

    lineHeight: '1.25'

  },


  /* ========================================================
     STRENGTHS
  ======================================================== */

  strengthsList: {

    display: 'flex',

    flexDirection: 'column',

    gap: '8px'

  },


  strengthRow: {

    display: 'flex',

    alignItems: 'center',

    gap: '10px'

  },


  strengthBadgeIcon: {

    width: '28px',

    height: '28px',

    borderRadius: '50%',

    backgroundColor: '#c5a059',

    color: '#0b2545',

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'center',

    fontSize: '11px',

    flexShrink: 0

  },


  strengthText: {

    fontSize: '12px',

    color: '#333',

    fontWeight: '500',

    lineHeight: '1.35'

  },


  /* ========================================================
     GALLERY HEADING
  ======================================================== */

  galleryHeading: {

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'center',

    gap: '10px',

    margin:
      '30px 0 18px'

  },


  galleryHeadingLine: {

    width: '100px',

    height: '1px',

    backgroundColor: '#d4b36b'

  },


  galleryStar: {

    color: '#c5a059',

    fontSize: '10px'

  },


  galleryTitle: {

    margin: 0,

    color: '#0b2545',

    fontSize: '17px',

    letterSpacing: '1px'

  },


  /* ========================================================
     GALLERY
  ======================================================== */

  bottomGalleryGrid: {

    display: 'grid',

    gridTemplateColumns:
      'repeat(3, 1fr)',

    gap: '15px',

    marginBottom: '22px',

    height: '180px',

    width: '100%'

  },


  bottomGalleryCard: {

    borderRadius: '9px',

    overflow: 'hidden',

    backgroundColor: '#eee',

    position: 'relative'

  },


  galleryImg: {

    width: '100%',

    height: '100%',

    objectFit: 'cover',

    display: 'block'

  },


  galleryOverlay: {

    position: 'absolute',

    left: 0,

    right: 0,

    bottom: 0,

    padding: '10px 12px',

    background:
      'linear-gradient(transparent,rgba(11,37,69,.88))',

    color: '#fff',

    fontSize: '10px',

    fontFamily: 'sans-serif',

    letterSpacing: '.5px'

  },


  /* ========================================================
     CALLOUT
  ======================================================== */

  calloutBanner: {

    background:
      'linear-gradient(135deg,#0b2545,#153b60)',

    color: '#fff',

    borderRadius: '7px',

    padding: '16px 25px',

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'space-between',

    margin:
      '18px 0',

    width: '100%',

    boxShadow:
      '0 8px 25px rgba(11,37,69,.15)'

  },


  ornamentLeft: {

    color: '#c5a059',

    fontSize: '20px'

  },


  ornamentRight: {

    color: '#c5a059',

    fontSize: '20px'

  },


  calloutText: {

    margin: 0,

    fontSize: '15px',

    color: '#c5a059',

    letterSpacing: '1px',

    textAlign: 'center',

    lineHeight: '1.5'

  },


  /* ========================================================
     FOOTER
  ======================================================== */

  footer: {

    display: 'flex',

    alignItems: 'center',

    justifyContent: 'space-between',

    paddingTop: '15px',

    borderTop:
      '1px solid #e5dfd5',

    fontFamily: 'sans-serif',

    width: '100%'

  },


  footerBadge: {

    backgroundColor: '#c5a059',

    color: '#0b2545',

    fontSize: '18px',

    fontWeight: 'bold',

    padding: '7px 14px',

    borderRadius: '4px',

    boxShadow:
      '0 5px 12px rgba(197,160,89,.22)'

  },


  footerCompany: {

    display: 'flex',

    flexDirection: 'column',

    fontSize: '11px',

    color: '#0b2545',

    lineHeight: '1.5'

  },


  footerLink: {

    display: 'flex',

    alignItems: 'center',

    fontSize: '11px',

    color: '#0b2545'

  },


  linkText: {

    color: '#0b2545',

    textDecoration: 'none',

    fontWeight: 'bold'

  }

};